import AreaByDepartment from './AreaByDepartment'
import SeatedEmployeesByDepartment from './SeatedEmployeesByDepartment'
import SeatsByDepartment from './SeatsByDepartment'
import SpaceTypes from './SpaceTypes'
import SpacesByUsageTypes from './SpacesByUsageTypes'

export default {
  AreaByDepartment,
  SeatedEmployeesByDepartment,
  SeatsByDepartment,
  SpacesByUsageTypes,
  SpaceTypes,
}
